<template>
        <div class="top_tab_area">
            <div class="sc03_stab01"> 
                <a v-for="tab in openApiTab" href="javascript:void(0)" :class="[selectedOpenApiTab === tab.code ? 'on' : '']" :key="tab.code"
                    @click.prevent="selectOpenApiTab(tab.code)">
                    {{ tab.name }}
                </a>
            </div>
        </div>
</template>

<script>
import {$_WC} from '@/confs/common.const.js';
import {mapGetters} from "vuex";
export default {
    data() {
        return {
            code: '',
        }
    },
    computed: {
        ...mapGetters({
            openApiTab: 'getOpenApiTab',
            selectedOpenApiTab: 'getSelectedOpenApiTab',
        }),
    },
    watch: {
    },
    created() {

    },
    methods: {
        selectOpenApiTab(code) {
            this.$store.dispatch('SET_SELECTED_OPEN_API_TAB', code);
        },
    },
}
</script>
